import { render, staticRenderFns } from "./DebugBar.vue?vue&type=template&id=56e44e88&scoped=true&"
import script from "./DebugBar.vue?vue&type=script&lang=js&"
export * from "./DebugBar.vue?vue&type=script&lang=js&"
import style0 from "./DebugBar.vue?vue&type=style&index=0&id=56e44e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e44e88",
  null
  
)

export default component.exports